import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NzButtonModule } from 'ng-zorro-antd/button';

import { UiIconsList, UiIconsModule } from 'ui-icons';

import { UiPlatformButtonType } from './button.model';

@Component({
  selector: 'ui-platform-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NgClass,
    NgTemplateOutlet,
    RouterLink,
    UiIconsModule,
    NzButtonModule
  ]
})
export class UiPlatformButtonComponent {
  @Input() label = '';
  @Input() type: UiPlatformButtonType = 'primary';
  @Input() icon: UiIconsList | undefined;
  @Input() iconPlacement: 'left' | 'right' = 'left';
  @Input() textSize: 'standard' | 'smaller' = 'standard';
  @Input() horizontalPadding: 'standard' | 'smaller' = 'standard';
  @Input() disabled = false;
  @Input() inProgress = false;
  @Input() lighterIcon = false;
  @Input() classes: string[] = [];
  @Input() outsideURL: string | null = null;
  @Input() routerURL: string | any[] | null = null;

  get classList() {
    const classes: string[] = [];

    if ([
        'warn',
        'secondary',
        'text'
      ].includes(this.type)) {
      classes.push(`ant-btn-${this.type}`);
    }

    if ([
        'link',
        'link-primary',
        'link-secondary'
      ].includes(this.type)) {
      classes.push(`ant-anchor-${this.type}`);
    }

    if (this.type === 'text-primary') {
      classes.push('sh-btn-primary-text');
    }

    if (this.textSize === 'smaller') {
      classes.push('sh-btn-font-smaller');
    }

    // special handling if we have only icon with no text - the padding is smaller
    if (!this.label || this.horizontalPadding === 'smaller') {
      classes.push('sh-btn-padding-smaller');
    }

    if (this.classes?.length) {
      classes.push(...this.classes);
    }

    return classes;
  }

  get iconKey() {
    return this.icon as UiIconsList;
  }

  get hasLighterIcon() {
    return this.lighterIcon;
  }

  get nzType() {
    if (this.type === 'secondary') {
      return 'default';
    }

    if ([
        'text',
        'text-primary'
      ].includes(this.type)) {
      return 'text';
    }

    if ([
        'link',
        'link-primary',
        'link-secondary'
      ].includes(this.type)) {
      return 'link';
    }

    return 'primary';
  }
}
